export const fields = [
    { label: 'ID', value: 'id' },
    { label: 'Offering', value: 'offering' },
    { label: 'Investment Type – Entity/Individual', value: 'investment_type' },
    { label: 'Subscriber', value: 'subscriber' },
    { label: 'Dealing Rep', value: 'dealing_rep' },
    { label: 'Status', value: 'status' },
    { label: 'Registered - y/n', value: 'registered' },
    { label: 'Trustee - if applicable', value: 'trustee' },
    { label: 'Account – type', value: 'account_type' },
    { label: 'Registered Account – if existing', value: 'registered_account' },
    { label: '# of Securities', value: 'number_of_securities' },
    { label: 'Subscription Amount', value: 'subscription_amount' },
    { label: 'Commission Paid', value: 'commission_paid' },
    { label: 'Commission Percentage/Fee', value: 'commission_percentage_fee' },
    { label: 'Subscriber Address', value: 'subscriber_address' },
    { label: 'City', value: 'city' },
    { label: 'Province', value: 'province' },
    { label: 'Postal Code', value: 'postal_code' },
    { label: 'Subscriber Email', value: 'subscriber_email' },
    { label: 'Subscriber Phone', value: 'subscriber_phone' },
    { label: 'Subscriber Tax ID – SIN, SSN, BIN, TIN', value: 'subscriber_tax_id' },
    { label: 'Distribution Bank Name on Account', value: 'distribution_bank_name_account' },
    { label: 'Distribution Bank Name', value: 'distribution_bank_name' },
    { label: 'Distribution Bank Address', value: 'distribution_bank_address' },
    { label: 'Distribution Bank City', value: 'distribution_bank_city' },
    { label: 'Distribution Bank Province', value: 'distribution_bank_province' },
    { label: 'Distribution Bank Postal Code', value: 'distribution_bank_postal_code' },
    { label: 'Tax Residence', value: 'tax_residency' },
    { label: 'Date of Birth – if individual', value: 'date_of_birth' },
];

export const additionalFields = [
    { label: 'Close Date', value: 'closed_on' },
    { label: 'Transaction Type – Purchase', value: 'transaction_type' },
    { label: 'Purchased Past 12', value: 'purchased_past_12' },
    { label: 'Owner 1 Name – if relying on exemption', value: 'owner_1_name' },
    { label: 'Owner 1 Address', value: 'owner_1_address' },
    { label: 'Owner 1 Status', value: 'owner_1_status' },
    { label: 'Owner 2 Name – if relying on exemption', value: 'owner_2_name' },
    { label: 'Owner 2 Address', value: 'owner_2_address' },
    { label: 'Owner 2 Status', value: 'owner_2_status' },
    { label: 'Owner 3 Name – if relying on exemption', value: 'owner_3_name' },
    { label: 'Owner 3 Address', value: 'owner_3_address' },
    { label: 'Owner 3 Status', value: 'owner_3_status' },
    { label: 'Owner 4 Name – if relying on exemption', value: 'owner_4_name' },
    { label: 'Owner 4 Address', value: 'owner_4_address' },
    { label: 'Owner 4 Status', value: 'owner_4_status' },
    { label: 'Joint Subscriber Name', value: 'joint_subscriber_name' },
    { label: 'Joint Subscriber Address', value: 'joint_subscriber_address' },
    { label: 'Joint Subscriber Email', value: 'joint_subscriber_email' },
    { label: 'Joint Subscriber Phone', value: 'joint_subscriber_phone' },
    { label: 'Joint Subscriber SIN, SSN', value: 'joint_subscriber_tax_id' },
    { label: 'Joint Tax Residence', value: 'joint_tax_residence' },
];

